import React, { forwardRef, useContext } from 'react';
import classNames from 'classnames/bind';
import { getLanguagesSet } from "../../constants";
import { PageNavigatorContext } from "../../PageNavigator";
import { ChevronNormalDown } from "../../../icons";
import { ButtonBase } from "../../../internal/ButtonBase";
import { TextBase } from "../../../internal/TextBase";
import styles from "./PaginationSelect.css";
var cx = classNames.bind(styles);
export var Button = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var total = _ref.total,
      isOpen = _ref.isOpen,
      setIsOpen = _ref.setIsOpen;

  var _useContext = useContext(PageNavigatorContext),
      locale = _useContext.locale;

  var _getLanguagesSet = getLanguagesSet(locale),
      translations = _getLanguagesSet.translations;

  return /*#__PURE__*/React.createElement(ButtonBase, {
    className: cx('button', {
      isOpen: isOpen
    }),
    onClick: setIsOpen,
    ref: ref
  }, /*#__PURE__*/React.createElement(TextBase, null, translations.titleShow, " ", translations.titleBy, " ", total), /*#__PURE__*/React.createElement(ChevronNormalDown, {
    classes: {
      root: cx('icon')
    }
  }));
});